import React from "react";
import { Box } from "@mui/material";
import { styled, useTheme } from "@mui/system";
import img from "../../../Assets/logo-removebg.png";

const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[900] : "#f5f5f5",
  height: "100%",
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(4),
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: theme.spacing(4),
}));

const LogoImage = styled("img")({
  width: 500,
  height: 500,
  objectFit: "contain",
});

const Dashboard = () => {
  const theme = useTheme();

  return (
    <StyledContainer>
      <LogoContainer>
        <LogoImage src={img} alt="Dashboard Logo" />
      </LogoContainer>
    </StyledContainer>
  );
};

export default Dashboard;
